import { useMutation, useQuery, useQueryClient } from "react-query";
import { parseCookies } from "nookies";
// import { GetprofileDatasadad } from "@/api/functions/user.api";
import { logout, setLoginData } from "../../redux-toolkit/slices/userSlice";

import { useSnackbar } from "notistack";
import axiosInstance from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";
import { useAppDispatch } from "../useAppDispatch";
import { useAppSelector } from "../useAppSelector";
// import { IFormInput } from "@/interface/common.interface";
import { GetprofileData } from "../../api/functions/user.api";
import { setCookieClient } from "../../lib/functions/storage.lib";

const useUser = () => {
  const cookies = parseCookies();
  const token = cookies?.token;

  const dispatch = useAppDispatch();
  // const { userData } = useAppSelector((s) => s.userSlice);

  const profileDetails = useQuery(
    "userdetails",
    () => GetprofileData({ id: JSON.parse(cookies?.userdetails || "")?.id }),
    {
      // enabled: !!token && userData === null,
      onSuccess(data) {
        dispatch(setLoginData(data));
        setCookieClient("userdetails", JSON.stringify(data || {}));
      },
      onError(err) {
        // dispatch(logout());
      },
    }
  );

  return {
    profileDetails,
    //  profileUpdateMutation
  };
};

export const useforgotpassword = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(async (post) => {
    return axiosInstance
      .post(endpoints.auth.forgotPassword, post)
      .then(({ data }) => {
        enqueueSnackbar(data?.message, { variant: "success" });
        return data;
      })
      .catch(({ response }) => {
        // enqueueSnackbar(response?.data?.message, { variant: "error" });
        return response;
      });
  });
};

export const useLogin = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(async (post) => {
    return axiosInstance
      .post(endpoints.auth.login, post)
      .then(({ data }) => {
        // enqueueSnackbar(data?.message, { variant: "success" });
        return data;
      })
      .catch(({ response }) => {
        return response;
      });
  });
};

// export const useReviewWrite = (initialData) => {
//   const res = useQuery(["GetprofileData", param], GetprofileDatasadad, {
//     initialData,

//   });

//   return res;
// };

// export const useOTPverification = () => {
//   const queryClient = useQueryClient();
//   const { enqueueSnackbar } = useSnackbar();
//   return useMutation(async (post) => {
//     return axiosInstance
//       .post(endpoints.auth.otpverify, post)
//       .then(({ data }) => {
//         enqueueSnackbar(data?.message, { variant: "success" });
//         return data;
//       })
//       .catch(({ response }) => {
//         enqueueSnackbar(response?.data?.message, { variant: "error" });
//       });
//   });
// };

export const useOTPverification = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(async (post) => {
    console.warn(post, "asddsa");

    return axiosInstance
      .post(endpoints.auth.otpverify, post)
      .then(({ data }) => {
        enqueueSnackbar(data?.message, { variant: "success" });
        return data;
      })
      .catch(({ response }) => {
        // enqueueSnackbar(response?.data?.message, { variant: "error" });
        return response;
      });
  });
};

export const useResetPassword = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(async (post) => {
    console.warn(post, "asddsa");

    return axiosInstance
      .post(endpoints.auth.resetpassword, post)
      .then(({ data }) => {
        enqueueSnackbar(data?.message, { variant: "success" });
        return data;
      });
  });
};

export const usecopywriterschangepassword = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(async (post) => {
    console.warn(post, "asddsa");

    return axiosInstance
      .post(endpoints.copyWritersDashboard.chnagePassword, post)
      .then(({ data }) => {
        enqueueSnackbar(data?.message, { variant: "success" });
        return data;
      });
  });
};

export const editorChangePassword = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(async (post) => {
    console.warn(post, "asddsa");

    return axiosInstance
      .post(endpoints.editorDashboard.chnagePassword, post)
      .then(({ data }) => {
        enqueueSnackbar(data?.message, { variant: "success" });
        return data;
      });
  });
};

export default useUser;
